var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMintingAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_13824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62 16.74C13.1046 16.74 16.74 13.1046 16.74 8.62C16.74 4.13545 13.1046 0.5 8.62 0.5C4.13545 0.5 0.5 4.13545 0.5 8.62C0.5 13.1046 4.13545 16.74 8.62 16.74Z",
    stroke: "#20CE6A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61914 12.5499C7.61914 12.3521 7.67779 12.1588 7.78767 11.9943C7.89755 11.8299 8.05373 11.7017 8.23646 11.626C8.41918 11.5503 8.62025 11.5305 8.81423 11.5691C9.00821 11.6077 9.18639 11.7029 9.32625 11.8428C9.4661 11.9826 9.56134 12.1608 9.59993 12.3548C9.63851 12.5488 9.61871 12.7499 9.54302 12.9326C9.46733 13.1153 9.33916 13.2715 9.17471 13.3814C9.01026 13.4913 8.81692 13.5499 8.61914 13.5499C8.35392 13.5499 8.09957 13.4445 7.91203 13.257C7.7245 13.0695 7.61914 12.8151 7.61914 12.5499ZM7.90914 5.1799V3.6499H9.40914V5.1799L9.19914 10.3699H8.19914L7.90914 5.1799Z",
    fill: "#20CE6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_13824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.24,
    height: 17.24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintingAlert);
export default __webpack_public_path__ + "static/media/minting_alert.07823c39144949f6cfa68a90efb05f54.svg";
export { ForwardRef as ReactComponent };